<template>
  <div>
    <div class="card-body p-0" v-if="errors.length">
        <base-alert  type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>
    </div>
    <h2><span v-if="this.$attrs.actionStatus=='Edit'">Edit</span><span v-if="this.$attrs.actionStatus!='Edit'">Setup</span> product for Lazada
        <div class="float-right">
            <a-button type="primary" class="btn btn-primary float-right btn-sm border-sm mr-0" v-if="this.$attrs.actionStatus=='Edit'" :loading="saveLoading" @click.prevent="updateParams">Update</a-button>
            <a-button type="primary" class="btn btn-primary float-right btn-sm border-sm mr-0" v-else-if="this.$attrs.actionStatus!='Edit'" :loading="saveLoading" @click.prevent="saveParams">Save</a-button>
            <a-button type="primary" class="btn float-right mr-0 bg-white text-dark mr-3 btn-sm" @click.prevent="$emit('closeProductFrom', null)">Cancel</a-button>
        </div>
    </h2>
    <div class="row mt-4 overflow-auto" style="height: 44rem;">
        <div class="col-md-12">
            <a-collapse v-model="activeKey" expand-icon-position="right" class="border-0 bg-white">
                <a-collapse-panel key="1" header="01. Basic Information" :style="customStyle">
                    <base-input v-model="LazadaTemplate.Attributes.name" input-classes="form-control form-control-sm" label="Product Name" required />
                    <div class="form-group has-label"><label class="form-control-label">
                        Select Category<span>*</span></label>
                        <a-cascader
                            :field-names="{ label: 'name', value: 'category_id', children: 'children', isLeaf: 'leaf' }"
                            :options="categories"
                            placeholder="Please select category"
                            :show-search="{ filter }"
                            autocomplete="off"
                            @change="onChangeCategory"
                            v-model="LazadaTemplate.cascader_category"
                        />
                    </div>
                    <div class="row" v-if="LazadaTemplate.cascader_category.length>=1">
                         <div class="col-md-4" v-for="(att,attIndex) in attributes" v-if="(att.is_mandatory) 
                        && (att.name!='package_weight' && att.name!='quantity'&& att.name!='price' 
                        && att.name!='name' && att.name!='short_description' && att.name!='SellerSku' 
                        && att.name!='package_height' && att.name!='package_length' 
                        && att.name!='package_width') && (attIndex!=sizeAttributeIndex && attIndex!=ColorAttributeIndex)" :key="att.id">
                            <base-input v-if="att.input_type=='text' || att.input_type=='richText'" v-model="LazadaTemplate.Attributes[att.name]" :value="LazadaTemplate.Attributes[att.name]!=null? LazadaTemplate.Attributes[att.name] = LazadaTemplate.Attributes[att.name] : LazadaTemplate.Attributes[att.name] = null" input-classes="form-control form-control-sm" :label="att.label" required/>
                            <base-input v-else-if="att.input_type=='numeric'" v-model="LazadaTemplate.Attributes[att.name]" :value="LazadaTemplate.Attributes[att.name]!=null? LazadaTemplate.Attributes[att.name] = LazadaTemplate.Attributes[att.name] : LazadaTemplate.Attributes[att.name] = null" type="number" min="0" step="0.01" input-classes="form-control form-control-sm" :label="att.label" required/>
                            <base-input v-else-if="att.input_type=='date'" v-model="LazadaTemplate.Attributes[att.name]" :value="LazadaTemplate.Attributes[att.name]!=null? LazadaTemplate.Attributes[att.name] = LazadaTemplate.Attributes[att.name] : LazadaTemplate.Attributes[att.name] = null" type="date" input-classes="form-control form-control-sm" :label="att.label" required/>
                            <div class="form-group has-label" v-else-if="(att.input_type=='multiSelect' 
                            || att.input_type=='multiEnumInput' || att.input_type=='singleSelect') 
                            && (att.name!='brand')"><label class="form-control-label">
                                {{att.label}}<span>*</span></label>
                                <div hidden v-if="LazadaTemplate.Attributes[att.name]!=null? LazadaTemplate.Attributes[att.name] = LazadaTemplate.Attributes[att.name] : LazadaTemplate.Attributes[att.name] = null"
                                ></div>
                                <template>
                                    <select class="ant-select-selection ant-select-selection--single select-custom"
                                    v-model="LazadaTemplate.Attributes[att.name]"
                                    :placeholder="'Select ' + att.label">
                                        <option v-for="data in att.options" :key="data.name" :value="data.name" >{{data.name}}
                                        </option>
                                    </select>
                                </template>
                            </div>
                            <div class="form-group has-label" v-else-if="att.name=='brand'"><label class="form-control-label">
                                {{att.label}}<span>*</span></label>
                                <div hidden v-if="LazadaTemplate.Attributes[att.name]!=null? LazadaTemplate.Attributes[att.name] = LazadaTemplate.Attributes[att.name] : LazadaTemplate.Attributes[att.name] = null"
                                ></div>
                                <template>
                                    <a-select 
                                    v-model="LazadaTemplate.Attributes[att.name]"
                                    show-search
                                    :placeholder="'Select ' + att.label"
                                    :filter-option="false"
                                    :not-found-content="fetching ? undefined : null"
                                    @search="fetchBrand"
                                    @change="handleBrandChange">
                                        <a-spin v-if="fetching" slot="notFoundContent" size="small" class="d-flex justify-content-center"/>
                                        <a-select-option v-for="data in tempBrands.slice(0, 100)" :key="data.name" :value="data.name">{{data.name}}
                                        </a-select-option>
                                    </a-select>
                                </template>
                            </div>
                        </div>
                    </div>
                </a-collapse-panel>
                <a-collapse-panel key="2" header="02. Detailed Description"  :style="customStyle">
                    <div class="form-group has-label"><label class="form-control-label">
                        Short Description<span>*</span></label>
                        <quill-editor
                            ref="myQuillEditor"
                            v-model="LazadaTemplate.Attributes.short_description"
                            @blur="onEditorBlur($event)"
                            @focus="onEditorFocus($event)"
                            @ready="onEditorReady($event)"
                        />
                    </div>
                    <div class="form-group has-label"><label class="form-control-label">
                        Long Description<span>*</span></label>
                        <quill-editor
                            ref="myQuillEditor"
                            v-model="LazadaTemplate.Attributes.description"
                            @blur="onEditorBlur($event)"
                            @focus="onEditorFocus($event)"
                            @ready="onEditorReady($event)"
                        />
                    </div>
                </a-collapse-panel>
                <a-collapse-panel key="3" header="03. Price & Stock" v-if="LazadaTemplate.cascader_category.length>=1" :style="customStyle">
                    <div class="row" v-if="productDetails.product_type !='M'">
                        <div class="col-md-3 p-2 pl-3">
                            <base-input label="Price">
                            <div class="input-group mb-3">
                                <input class="form-control form-control-sm" min="1" step="0.01" type="number" :disabled="defaultPrice=='R'" v-model="LazadaTemplate.price" required>
                                <div class="input-group-append d-flex">
                                    <base-dropdown v-model="defaultPrice">
                                        <base-button slot="title" type="secondary"
                                            class="btn-outline-primary dropdown-toggle dropdown-toggle-split"
                                            style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;padding-top: 6px;padding-bottom: 6px;" />
                                        <a class="dropdown-item" v-if="defaultPrice!='R'" @click.prevent="changeDefaultPrice('R')">Retail Price</a>
                                        <a class="dropdown-item"  v-if="defaultPrice!='C'" @click.prevent="changeDefaultPrice('C')">Custom Price</a>
                                    </base-dropdown>
                                </div>
                            </div>
                            </base-input>
                            <!-- <base-input v-model="LazadaTemplate.price" input-classes="form-control form-control-sm" min="1" step="0.01" type="number" label="Price" required/> -->
                        </div>
                        <div class="col-md-3 p-2" >
                            <base-input v-model="LazadaTemplate.quantity" input-classes="form-control form-control-sm" min="0" type="number" label="Stock" required disabled/>
                        </div>
                        <div class="col-md-3 p-1">
                            <base-input v-model="LazadaTemplate.SellerSku" :disabled="this.$attrs.actionStatus=='Edit'" input-classes="form-control form-control-sm" label="Seller SKU" required/>
                        </div>
                    </div>
                    <div class="row" v-if="productDetails.product_type =='M'">
                        <div class="col-md-12">
                            <base-input label="Default Price" input-classes="form-control form-control-sm">
                            <br>
                            <a-radio-group v-model="defaultPrice">
                                <a-radio-button @click.prevent="changeDefaultPrice('R')" value="R">Retail Price</a-radio-button>
                                <a-radio-button @click.prevent="changeDefaultPrice('C')" value="C">Custom Price</a-radio-button>
                            </a-radio-group>
                            </base-input>
                            <div class="table-responsive">
                                <table class="table table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            <th v-if="sizeAttributeIndex>=0">Size</th>
                                            <th v-if="ColorAttributeIndex>=0">Color Family</th> 
                                            <th>Seller SKU</th>
                                            <th>Quantity</th>
                                            <th>Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(subProduct,subProductIndex) in LazadaTemplate.Skus" v-bind:key="subProductIndex">
                                            <td v-if="sizeAttributeIndex>=0">
                                                <a-select 
                                                v-model="LazadaTemplate.Skus[subProductIndex].size"
                                                show-search
                                                placeholder="Select Size">
                                                    <a-select-option v-for="data in attributes[sizeAttributeIndex].options" :key="data.name" :value="data.name">{{data.name}}
                                                    </a-select-option>
                                                </a-select>
                                            </td>
                                            <td v-if="ColorAttributeIndex>=0">
                                                <a-select 
                                                v-model="LazadaTemplate.Skus[subProductIndex].color_family"
                                                show-search
                                                placeholder="Select Color">
                                                    <a-select-option v-for="data in attributes[ColorAttributeIndex].options" :key="data.name">{{data.name}}
                                                    </a-select-option>
                                                </a-select>
                                            </td>
                                            <td><base-input v-model="LazadaTemplate.Skus[subProductIndex].SellerSku" :disabled="$attrs.actionStatus=='Edit'" input-classes="form-control form-control-sm" required /></td>
                                            <td><base-input disabled min="0" max="5000" type="number" v-model="LazadaTemplate.Skus[subProductIndex].quantity" input-classes="form-control form-control-sm" required /></td>
                                            <td><base-input min="1" type="number" :disabled="defaultPrice=='R'" v-model="LazadaTemplate.Skus[subProductIndex].price" input-classes="form-control form-control-sm" required style="width: 6rem;" /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                  </a-collapse-panel>
                <a-collapse-panel key="4" header="04. Delivery"  :style="customStyle">
                    <div class="row">
                        <div class="col p-1 pl-3">
                            <base-input v-model="LazadaTemplate.package_weight" input-classes="form-control form-control-sm" min="0.01" step="0.01" type="number" label="Weight (kg)" required/>
                        </div>
                        <div class="col p-1">
                            <base-input v-model="LazadaTemplate.package_height" input-classes="form-control form-control-sm" min="0.01" step="0.01" type="number" label="Height (cm)" required/>
                        </div>
                        <div class="col p-1">
                            <base-input v-model="LazadaTemplate.package_width" input-classes="form-control form-control-sm" min="0.01" step="0.01" type="number" label="Width (cm)" required/>
                        </div>
                        <div class="col p-1 pr-3">
                            <base-input v-model="LazadaTemplate.package_length" input-classes="form-control form-control-sm" min="0.01" step="0.01" type="number" label="Length (cm)" required/>
                        </div>
                    </div>
                </a-collapse-panel>
            </a-collapse>
        </div>
    </div>
  </div>
</template>
<script>
    import axios from "axios";
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import secureStorage from '../../controllers/secureStorage.js'
    import Quill from 'quill'
    import { mapState } from 'vuex'
    var component_x;
    export default {
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType','publicUrl']),
        },
        mounted: async function(){
            component_x = this
            this.imageUrl = this.publicUrl + 'product_images'
            this.accessToken = this.$attrs.LazadaAccessToken
            var arr = this.$attrs.productIntegrationData
            this.salesChannelId = this.$attrs.salesChannelId
            if (this.$attrs.actionStatus == "Edit"){
                this.LazadaTemplate = arr.lazadaParams
                this.defaultPrice = arr.default_price 
                this.getAttributes(true)
            }else {
                if (arr.product_type == "M"){
                    var response = await HTTPRequest.getRequest(this.endPoint + 'marketplace_integrations/get_sub_product_details?id='+arr.id+'&site_id='+this.$attrs.siteId+'&sublocation_id='+this.$attrs.selectedSublocationId+'&percent='+this.$attrs.inventoryPercentage, null)
                    arr.sub_products = response
                }else {
                    this.LazadaTemplate.SellerSku = arr.stock_no
                    this.LazadaTemplate.price = arr.retail_price
                    this.getProductAvailableQuantity(arr.id)
                }
                this.LazadaTemplate.Attributes.name = arr.name
                this.LazadaTemplate.package_weight = arr.weight
                this.LazadaTemplate.package_height = arr.height
                this.LazadaTemplate.package_width = arr.width
                this.LazadaTemplate.package_length = arr.length
            }
            this.productDetails = arr
            this.getCategories()
        },
        data(){
            return {
                accessToken:null,
                saveLoading:false,
                categories:[],
                imageUrl:null,
                errors:[],
                activeKey:['1','2','3','4'],
                customStyle:"margin-bottom: 24px;border: 1px solid #dee2e6!important;background-color: #fafafa;",
                attributes:[],
                brands:[],
                tempBrands:[],
                fetching:false,
                productDetails:[],
                sizeAttributeIndex:-1,
                ColorAttributeIndex:-1,
                LazadaTemplate:{
                    PrimaryCategory:null,
                    Attributes:{
                        name:null,
                        short_description:null,
                        description:null,
                        brand:null,
                    },
                    Skus:[],
                    SellerSku:null,
                    quantity:null,
                    price:null,
                    package_length:null,
                    package_height:null,
                    package_weight:null,
                    package_width:null,
                    cascader_category:[],
                },
                tempBrandValue:null,
                nextBrandSearch:false,
                salesChannelId:null,
                defaultPrice:null,
            }
        },
        methods: {
            getCategories: async function(){
                var response = await HTTPRequest.postRequest(this.endPoint+ 'lazada_integrations/categories', null, {access_token:this.accessToken})
                if (response["error"] == undefined){
                    this.categories = response["data"]
                }else {
                    this.errors = response["error"].split(",")
                }
            },
            onChangeCategory(value){
                if (value.length > 0){
                    this.getAttributes()
                }
            },
            filter(inputValue, path) {
                return (path.some(option => (option.name).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
            },
            getAttributes: async function(status){
                this.LazadaTemplate.PrimaryCategory = this.LazadaTemplate.cascader_category[this.LazadaTemplate.cascader_category.length - 1]
                var response = await HTTPRequest.postRequest(this.endPoint+ 'lazada_integrations/attributes', null, {access_token:this.accessToken,category_id:this.LazadaTemplate.cascader_category[this.LazadaTemplate.cascader_category.length - 1]})
                if (response["error"] == undefined){
                    this.attributes = response["data"]
                    if (this.brands.length == 0){
                        this.getBrands()
                    }
                    if (status==undefined){
                        this.LazadaTemplate.Attributes = {
                            name:this.LazadaTemplate.Attributes.name!=null ? this.LazadaTemplate.Attributes.name : this.productDetails.name!=null ? this.productDetails.name : null,
                            short_description:this.LazadaTemplate.Attributes.short_description!=null ? this.LazadaTemplate.Attributes.short_description : this.productDetails.short_description!=null ? this.productDetails.short_description : null,
                            description:this.LazadaTemplate.Attributes.description!=null ? this.LazadaTemplate.Attributes.description : this.productDetails.description!=null ? this.productDetails.description : null,
                        }
                    }
                    if(this.productDetails.product_type == "M"){
                        this.getVariationBaseOnSelectedCategory(status)
                    }
                }else {
                    this.errors = response["error"].split(",")
                }
            },
            onEditorBlur(quill) {
                //console.log('editor blur!', quill)
            },
            onEditorFocus(quill) {
                //console.log('editor focus!', quill)
            },
            onEditorReady(quill) {
                //console.log('editor ready!', quill)
            },
            onEditorChange({ quill, html, text }) {
                //console.log('editor change!', quill, html, text)
                this.LazadaTemplate.Attributes.short_description = html
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            getBrands: async function(){
                this.nextBrandSearch = true
                this.LazadaTemplate.Attributes
                let search = ''
                this.tempBrandValue!=null? search = this.tempBrandValue : ""
                var response = await HTTPRequest.postRequest(this.endPoint+ 'lazada_integrations/brands', null, {access_token:this.accessToken,search:search})
                if (response["error"] == undefined){
                    if (response.length < 500){
                        this.tempBrands = response
                        this.nextBrandSearch = false
                    }else{
                        this.brands = response
                        this.tempBrands = response
                        this.nextBrandSearch = false
                    }
                }else {
                    this.errors = response["error"].split(",")
                }
            },
            fetchBrand(value){
                this.fetching = true;
                this.tempBrands = this.searchBrand(value)
                if (this.tempBrands.length<1 && !this.nextBrandSearch){
                    this.tempBrandValue = value
                    this.getBrands()
                }
            },
            handleBrandChange(value){
                this.LazadaTemplate.Attributes.brand = value
                this.tempBrandValue = value
                this.fetchBrandNextCall = false
                this.tempBrands = []
                this.fetching = false
            },
            handleOtherSelectChange(value,data){
                console.log(value,data)
            },
            searchBrand(value){
                return this.brands.filter( brand => {
                return !value ||
                    brand.name.toLowerCase().indexOf(value.toLowerCase()) > -1
                })
            },
            getProductAvailableQuantity: async function(id){
                var response = await HTTPRequest.getRequest(this.endPoint+ 'marketplace_integrations/get_product_stock?id='+id+'&site_id='+this.$attrs.siteId+'&sublocation_id='+this.$attrs.selectedSublocationId, null)
                if (response!=null){
                    if (response["error"] == undefined){
                        this.LazadaTemplate.quantity = (response.available_quantity*this.$attrs.inventoryPercentage)/100
                        this.LazadaTemplate.quantity = this.LazadaTemplate.quantity<0 ? 0 : this.LazadaTemplate.quantity
                    }else {
                        this.LazadaTemplate.quantity = 0
                    }
                }else{
                    this.LazadaTemplate.quantity = 0
                }
            },
            getVariationBaseOnSelectedCategory(status){
                var color_family_index = this.attributes.findIndex(x => x.name =='color_family')
                if (color_family_index>=0){
                    this.ColorAttributeIndex = color_family_index
                }else{
                    this.ColorAttributeIndex = -1
                }
                var size_index = this.attributes.findIndex(x => x.name =='size')
                if (size_index>=0){
                    this.sizeAttributeIndex = size_index
                }else {
                    this.sizeAttributeIndex = -1
                }
                if (status == undefined){
                    this.LazadaTemplate.Skus = []
                    this.productDetails.sub_products.forEach((value, index) => {
                        var array = {
                            SellerSku:value.stock_no,
                            quantity:value.available_quantity,
                            price:value.retail_price,
                        }
                        if (index!=0){
                            array.SellerSku = value.stock_no+'-'+index
                        }
                        if (component_x.sizeAttributeIndex>=0){
                            array.size = value.size_name
                        }
                        if (component_x.ColorAttributeIndex>=0){
                            if (component_x.sizeAttributeIndex<0 && value.size_name!=null && value.color_name!=null && value.design_name!=null){
                                array.color_family = value.size_name + ' - ' + value.color_name + ' - ' + value.design_name
                            }else if (value.color_name!=null && value.design_name==null){
                                array.color_family = value.color_name 
                            }else if(value.color_name==null && value.design_name!=null){
                                array.color_family = value.design_name 
                            }else if (value.color_name!=null && value.design_name!=null){
                                array.color_family = value.color_name + ' - ' + value.design_name
                            }
                        }
                        component_x.LazadaTemplate.Skus.push(array)
                    });
                }
            },
            validation(){
                this.errors = [];
                this.errors.push(ValidateField.required('Category', this.LazadaTemplate.PrimaryCategory));
                for (const name in this.LazadaTemplate.Attributes) {
                    this.errors.push(ValidateField.required(name, this.LazadaTemplate.Attributes[name]));
                }
                if (this.productDetails.product_type == 'M'){
                    this.LazadaTemplate.Skus.forEach((value, index) => {
                        for (const name in value) {
                            if (name!='quantity'){
                                this.errors.push(ValidateField.required(name + " for row number " +(index+1), value[name]));
                            }
                        }
                    })
                }else {
                    this.errors.push(ValidateField.required('SellerSku', this.LazadaTemplate.SellerSku));
                    this.errors.push(ValidateField.required('Price', this.LazadaTemplate.price));
                }
                this.errors.push(ValidateField.required('Package Length', this.LazadaTemplate.package_length));
                this.errors.push(ValidateField.required('Package Height', this.LazadaTemplate.package_height));
                this.errors.push(ValidateField.required('Package Weight', this.LazadaTemplate.package_weight));
                this.errors.push(ValidateField.required('Package Width', this.LazadaTemplate.package_width));
                this.errors.push(ValidateField.greaterThanZero('Package Length', this.LazadaTemplate.package_length));
                this.errors.push(ValidateField.greaterThanZero('Package Height', this.LazadaTemplate.package_height));
                this.errors.push(ValidateField.greaterThanZero('Package Weight', this.LazadaTemplate.package_weight));
                this.errors.push(ValidateField.greaterThanZero('Package Width', this.LazadaTemplate.package_width));
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },
            async saveParams(){
                if(!this.validation()){
                    this.saveLoading = true
                    this.productDetails.lazadaParams = this.LazadaTemplate
                    this.productDetails.defaultPrice = this.defaultPrice
                    if (this.salesChannelId > 0){
                        var post_request =  await HTTPRequest.postRequest(this.endPoint+ 'lazada_integrations', null, {sales_channel_id:this.salesChannelId,product_details:this.productDetails})
                        if (post_request["error"] == undefined){
                            this.$notification['success']({
                                message: 'Success',
                                description: "successfully Created."
                            });
                            this.$emit('getPostedProductData', null)
                            this.$emit('allProductsData', null)
                            this.$emit('closeProductFrom', null)
                        }else {
                            component_x.errors.push(post_request["error"])
                        }
                    } else {
                        this.$emit('integrationAddProduct', this.productDetails)
                    }
                    this.saveLoading = false
                }
            },
            async updateParams(){
                if(!this.validation()){
                    this.saveLoading = true
                    this.productDetails.lazadaParams = this.LazadaTemplate
                    this.productDetails.defaultPrice = this.defaultPrice
                    if (this.salesChannelId > 0){
                        var post_request =  await HTTPRequest.putRequest(this.endPoint+ 'lazada_integrations/'+this.salesChannelId, null, {product_details:this.productDetails})
                        if (post_request["error"] == undefined){
                            this.$notification['success']({
                                message: 'Success',
                                description: "successfully Updated."
                            });
                            this.$emit('getPostedProductData', null)
                            this.$emit('allProductsData', null)
                            this.$emit('closeProductFrom', null)
                        }else {
                            component_x.errors.push(post_request["error"])
                        }
                    } else {
                        this.$emit('integrationUpdateProduct', this.productDetails)
                    }
                    this.saveLoading = false
                }
            },
            changeDefaultPrice(value){
                if (value == 'R'){
                    if (this.productDetails.product_type == 'M'){
                        this.productDetails.sub_products.forEach((value, index) => {
                            component_x.LazadaTemplate.Skus[index].price = value.retail_price
                        });
                    }else{
                        this.LazadaTemplate.price = this.productDetails.retail_price  
                    }
                }
                this.defaultPrice = value
            }
        }
    };
</script>